import React from 'react';

const GeneratorHeader = ({ onModeChange, onHelpClick, isDarkMode, toggleDarkMode, currentMode }) => {
  return (
    <div className="text-center mb-10 animate-fade-in-down relative">
      <h1 className={`font-['Orbitron'] font-black text-5xl md:text-6xl bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-500 animate-gradient-shift pb-2`}>
        Gen CC Ultimate
      </h1>
      <p className={`text-lg md:text-xl font-light ${isDarkMode ? 'text-gray-400' : 'text-gray-600'} mb-8`}>
        Generador de BINS futurista y de alta tecnología
      </p>
      
      <div className="flex justify-center items-center gap-4 flex-wrap">
        <button 
          onClick={() => onModeChange('normal')} 
          className={`btn-futuristic ${currentMode === 'normal' ? 'bg-gradient-to-r from-blue-500 to-indigo-600' : 'bg-gray-700 hover:bg-gray-600'} text-white py-3 px-6 rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105`}
        >
          <i className="fas fa-random mr-2"></i>Normal
        </button>
        <button 
          onClick={() => onModeChange('ordered')} 
          className={`btn-futuristic ${currentMode === 'ordered' ? 'bg-gradient-to-r from-blue-500 to-indigo-600' : 'bg-gray-700 hover:bg-gray-600'} text-white py-3 px-6 rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105`}
        >
          <i className="fas fa-list-ol mr-2"></i>Ordenado
        </button>
        <button 
          onClick={onHelpClick} 
          className="btn-futuristic bg-green-600 hover:bg-green-700 text-white py-3 px-6 rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105"
        >
          <i className="fas fa-question-circle mr-2"></i>Ayuda
        </button>
        
        <div className="flex items-center gap-2 ml-4">
          <i className={`fas fa-moon ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}></i>
          <label className="relative inline-flex items-center cursor-pointer">
            <input type="checkbox" checked={isDarkMode} onChange={toggleDarkMode} className="sr-only peer" />
            <div className="w-14 h-7 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border after:border-gray-300 after:rounded-full after:h-6 after:w-6 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
          </label>
          <i className={`fas fa-sun ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}></i>
        </div>
      </div>
    </div>
  );
};

export default GeneratorHeader;